// Centralised "Last reviewed" dates for every guide/long-read page.
// Update the date here when you materially revise a page's content.
// Format: ISO date string (YYYY-MM-DD).
export const REVIEWED_DATES = {
  "/": "2026-02-15",
  "/about": "2026-02-15",
  "/understanding": "2026-02-15",
  "/understanding/records": "2026-02-15",
  "/understanding/records/cheat-sheet": "2026-02-15",
  "/understanding/records/templates": "2026-02-15",
  "/understanding/records/chronology": "2026-02-15",
  "/understanding/meeting-prep": "2026-06-18",
  "/understanding/meeting-prep/cards": "2026-06-18",
  "/understanding/meeting-prep/debrief": "2026-06-18",
  "/understanding/records/complaint": "2026-06-18",
  "/glossary": "2026-02-15",
  "/support": "2026-02-15",
  "/campaign": "2026-02-15",
  "/privacy": "2026-02-15",
};

export function formatReviewedDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
